export default __webpack_public_path__ + "static/media/p2p-banners-id.6576273e.webp";